module.exports = __webpack_public_path__ + "img/waterLivestreamPipe.26fea1d7.svg";